import { render, staticRenderFns } from "./trade-agreements.vue?vue&type=template&id=d0a854da&"
import script from "./trade-agreements.vue?vue&type=script&lang=js&"
export * from "./trade-agreements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports